import { render, staticRenderFns } from "./ManualPickup.vue?vue&type=template&id=1c71cdb9&scoped=true"
import script from "./ManualPickup.vue?vue&type=script&lang=js"
export * from "./ManualPickup.vue?vue&type=script&lang=js"
import style0 from "./ManualPickup.vue?vue&type=style&index=0&id=1c71cdb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71cdb9",
  null
  
)

export default component.exports